import * as React from 'react';

import { Alert } from '@components/common';
import { useAccount } from '@hooks/useAccount';
import { useFeature } from '@hooks/useFeature';

import { notOnTeamHeading } from '../utils';

interface Props {
  teamUsersNotOnStudyTeamCount: number;
  studyTeam?: Team;
}

export const CollaboratorNotOnTeamAlert: React.FC<Props> = ({ teamUsersNotOnStudyTeamCount, studyTeam }) => {
  const hasTeamAccessControl = useFeature('team_access_control');
  const { account } = useAccount();

  if (!hasTeamAccessControl || !studyTeam || teamUsersNotOnStudyTeamCount <= 0) return null;

  return (
    <Alert type='error' className='my-6'>
      <span className='mb-1 block font-bold'>
        {notOnTeamHeading(teamUsersNotOnStudyTeamCount, account.visibility_permission_condition)}
      </span>
      <span className='block'>
        An account Admin can solve this by:
        <br />
        a) adding them to the {studyTeam.name} team
        <br />
        b) removing them from the collaborators list, or
        <br />
        c) adjusting the study's team to be a team these users are on.
      </span>
    </Alert>
  );
};
